import { Preferences } from '@capacitor/preferences';

export function jwtDecrypt(token) {
    if(token === undefined) {
        console.error('jwtDecrypt: token is undefined — clearing stored access_token.')
        Preferences.remove({key: 'access_token'}).then(r => console.log(r))
        //localStorage.removeItem("access_token")
    }
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function(c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );
    return JSON.parse(jsonPayload);
}

/**
 * @param exp
 * @returns {boolean}
 */
export function tokenAlive(exp) {
    return new Date() < Number(exp) * 1000;
}
